import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getDashboardDataAPI, updateSupportTicketReadStatusAPI } from "../../utils/api";
import { FaUsers, FaShoppingCart, FaBox, FaTags, FaStar, FaImage, FaVideo, FaGlobe, FaUserTie } from "react-icons/fa";
import { BiSolidCoupon } from "react-icons/bi";
import "./Dashboard.css";
import { useDispatch, useSelector } from "react-redux";
import { setNewTicketOrReply } from "../../store/slices/supportTicketState";

const Dashboard = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { newTicketOrReply } = useSelector((state) => state.supportTicketState);
  const [stats, setStats] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const defaultStats = [
    { _id: 2, name: "Sales Person", count: 0, link: "/Salesperson", icon: FaUserTie },
    { _id: 3, name: "Wholesale User", count: 0, link: "/Wholesaleuser", icon: FaUsers },
    { _id: 6, name: "Retail User", count: 0, link: "/Retailusers", icon: FaUsers },
    { _id: 7, name: "Order", count: 0, link: "/Order", icon: FaShoppingCart },
    { _id: 8, name: "Category", count: 0, link: "/Categories", icon: FaTags },
    { _id: 9, name: "Product", count: 0, link: "/Product", icon: FaBox },
    { _id: 10, name: "Brand", count: 0, link: "/Brand", icon: FaStar },
    { _id: 11, name: "Banner", count: 0, link: "/Banner", icon: FaImage },
    { _id: 16, name: "Video", count: 0, link: "/video", icon: FaVideo },
    { _id: 18, name: "Coupon", count: 0, link: "/coupons", icon: BiSolidCoupon },
    { _id: 12, name: "Country", count: 0, link: "/Country", icon: FaGlobe },
    // { _id: 13, name: "State", count: 0, link: "/State", icon: FaGlobe },
    // { _id: 14, name: "City", count: 0, link: "/City", icon: FaGlobe },
    // { _id: 15, name: "Pincode", count: 0, link: "/Pincode", icon: FaGlobe },
    { _id: 17, name: "Support Ticket", count: 0, link: "/Supportticket", icon: FaGlobe }
  ];

  const fetchDashboardData = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await getDashboardDataAPI();

      if (response?.status === 200) {
        const updatedStats = defaultStats?.map(defaultItem => {
          const apiItem = response?.data?.find(item => item?.name === defaultItem?.name);
          return apiItem ? { ...defaultItem, count: apiItem?.count } : defaultItem;
        });
        setStats(updatedStats);
        if (response?.new_ticket > 0 || response?.new_message > 0) {
          dispatch(setNewTicketOrReply(1));
        }else{
          dispatch(setNewTicketOrReply(0));
        }
      } else if (response?.message) {
        if (response?.message === "User ID not found. Please login again.") {
          localStorage.removeItem('adminToken');
          localStorage.removeItem('adminData');
          localStorage.removeItem('userId');
          localStorage.removeItem('user_Id');
          window.location.href = '/login';
        }
        setError(typeof response?.message === 'string'
          ? response?.message
          : 'Failed due to internal error');
        setStats([]);
      } else {
        setError('Failed due to internal error');
        setStats([]);
      }
    } catch (err) {
      setError('Failed due to internal error');
      setStats([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDashboardData();
  }, []);

  if (loading) {
    return (
      <div className="dashboard-loading">
        <div className="loading-spinner"></div>
        <p>Loading dashboard data...</p>
      </div>
    );
  }

  return (
    <div className="dashboard">
      <div className="dashboard-content">
        <div className="card-container">
          {stats?.map((item) => {
            return (
              <div
                className="card"
                key={item?._id}
                onClick={async () => {
                  if (item?.name?.toLowerCase() === 'support ticket') {
                    try {
                      await updateSupportTicketReadStatusAPI();
                    } catch (error) {
                      console.log('Error updating support ticket read status:', error);
                    }
                  }
                  navigate(item.link);
                }}
                style={{ cursor: "pointer" }}
              >
                {item?.name?.toLowerCase() === 'support ticket' && newTicketOrReply > 0 && (
                  <span className="dashoboard-ticket-dot"></span>
                )}
                <div className="card-icon">
                  {item?.count}
                </div>
                <p className="card-label">{item?.name}</p>
              </div>
            );
          })}
        </div>

        {error && (
          <div className="error-message">
            <p>{error}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Dashboard; 